import { environment } from '@quartz-gov-legacy/environments/environment';

(function () {
    'use strict';

    angular
        .module('planInitiativeModule')
        .factory('iniativeUpdateStatusReviewService', service);

    service.$inject = ['$http', '$q'];

    function service($http, $q) {
        var baseUrl = environment.apiUrl + '/Pilot/api/BusinessPlanning/InitiativeUpdateStatus';

        var service = {};

        // Get Assessments By Assessor
        service.getAssessmentsByAssessor = function (assessorID) {
            console.warn('using old service')
            //API/BusinessPlanning/InitiativeUpdateStatus/Assessor@{assessorId}/ToReview
            var reqUrl = baseUrl + '/Assessor@' + assessorID + '/ToReview';

            return $http.get(reqUrl)
                        .then(function (response) {
                            return response.data;
                        });
        };

        // Review Plan Initiative
        service.reviewPlanInitiative = function (planInitiativeAssessment) {
            console.warn('using old service')
            var reqUrl = baseUrl + '/Initiative/' + planInitiativeAssessment.PlanInitiativeID + '/Review';

            return $http.post(reqUrl, planInitiativeAssessment)
                        .then(function (response) {
                            return response.data;
                        });
        };

        // Review Plan Deliverable
        service.reviewPlanDeliverable = function (planInitiativeAssessment, planDeliverableAssessment) {
            console.warn('using old service')
            //API/BusinessPlanning/InitiativeUpdateStatus/Reviewer@{reviewerId}/Initiative/{planInitiativeId}/Deliverable/{planDeliverableId}/Review
            var reqUrl = baseUrl
                + '/Initiative/' + planInitiativeAssessment.PlanInitiativeID
                + '/Deliverable/' + planDeliverableAssessment.MilestoneGroupID
                + '/Review';

            return $http.post(reqUrl, planDeliverableAssessment)
                        .then(function (response) {
                            return response.data;
                        });
        };

        // Unlock Plan Initiative
        service.unlockPlanInitiative = function (planInitiativeAssessment) {
            console.warn('using old service')
            var reqUrl = baseUrl + '/Initiative/' + planInitiativeAssessment.PlanInitiativeID + '/Unlock';

            return $http.post(reqUrl, planInitiativeAssessment)
                        .then(function (response) {
                            return response.data;
                        });
        };

        // Lock Plan Initiative
        service.lockPlanInitiativeAssessment = function(planInitiativeAssessment) {
            console.warn('using old service')
            var reqUrl = baseUrl + '/Initiative/' + planInitiativeAssessment.PlanInitiativeID + '/Lock';

            return $http.post(reqUrl, planInitiativeAssessment)
                .then(function (response) {
                    return response.data;
                });
        };

        return service;
    }
})();
